const getAllPaymentMethods = ({ payments }) => payments.methods || []

const obj = {
  getAllPaymentMethods,
}

export default obj
